import appLogo from "../../assets/images/header-footer/app-logo.png";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/useAuth";

const Home = ({ isOpen, sidebarItems }) => {
  const navigate = useNavigate();
  const sidebarWidth = isOpen ? "w-72" : "w-0";
  const { t } = useTranslation();
  const { currentLang } = useAuth();

  return (
    <div className="home">
      <div className="flex flex-col">
        <div
          className={`h-screen bg-white shadow-xl bg-dark3 ${sidebarWidth} text-gray-600 ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          } transition-transform duration-300 ease-in-out transform overflow-hidden`}
        >
          {/* Render content only when sidebar is open */}
          {isOpen && (
            <div>
              <img 
                src={appLogo} 
                alt="App Logo" 
                className="h-14 mx-7 mt-10" 
              />
              
              <div className="flex flex-col px-5 py-6 font-medium text-lg space-y-1 mt-10">
                <span className="text-xs px-2 text-gray-600">{t("MENU")}</span>
                
                <button
                  onClick={() => {
                    navigate("/cpanel");
                  }}
                  className="text-left px-2 hover:bg-[#9B59B6] hover:text-white rounded-sm cursor-pointer duration-300 pt-2 pb-0.5 w-full"
                >
                  {currentLang === "en" ? "Dashboard" : "لوحة القيادة"}
                </button>
                
                <button
                  onClick={() => {
                    navigate("/customer-queries");
                  }}
                  className="text-left px-2 hover:bg-[#9B59B6] hover:text-white rounded-sm cursor-pointer duration-300 pt-2 pb-0.5 w-full"
                >
                  {currentLang === "en" ? "Customer Queries" : "استفسارات العملاء"}
                </button>
                
                {/* Sections List */}
                <div className="mt-5">
                  <span className="text-xs px-2 text-gray-600">{t("SECTIONS")}</span>
                  <div className="flex flex-col mt-2 space-y-1">
                    {sidebarItems &&
                      sidebarItems?.map((section, index) => (
                        <Link
                          key={index}
                          to={section.link || "#"}
                          className="px-2 hover:bg-[#9B59B6] hover:text-white rounded-sm cursor-pointer duration-300 pt-2 pb-0.5 block"
                        >
                          {section.label}
                        </Link>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;